import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MdClose } from 'react-icons/md';

interface Campaign {
  id: number;
  title: string;
  author: string;
  description: string;
  image: string;
  rating: string;
}

interface CampaignDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const CampaignDrawer: React.FC<CampaignDrawerProps> = ({ isOpen, onClose }) => {
  // Sample campaigns data
  const campaigns: Campaign[] = [
    {
      id: 1,
      title: 'The War and Treaty',
      author: 'Olivia Wilson',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      image: 'https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1770250692791-generated_flyer.jpeg',
      rating: 'Active'
    },
    {
      id: 2,
      title: 'The War and Treaty',
      author: 'Olivia Wilson',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      image: 'https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1770335265932-generated_flyer.jpeg',
      rating: 'Ongoing'
    },
    {
      id: 3,
     title: 'The War and Treaty',
      author: 'Olivia Wilson',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      image: 'https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1770250692791-generated_flyer.jpeg',
      rating: 'Active'
    }
    ,
    {
      id: 4,
      title: 'The War and Treaty',
      author: 'Olivia Wilson',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      image: 'https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1770335265932-generated_flyer.jpeg',
      rating: 'Active'
    }
  ];

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/60 z-40"
          />

          {/* Drawer */}
          <motion.div
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'spring', damping: 25, stiffness: 200 }}
            className="fixed right-0 top-0 h-full w-full max-w-md z-50 overflow-y-auto"
            style={{background: "linear-gradient(90deg, #212121eb, #373737eb)"}}
          >
            {/* Header */}
            <div className="sticky top-0 border-b border-gray-800 p-6 flex items-center justify-between z-10"
              style={{background: "linear-gradient(90deg, #212121eb, #373737eb)"}}
            >
              <h2 className="text-xl font-semibold text-[#EE4423]">More Campaigns</h2>
              <button
                onClick={onClose}
                className="p- cursor-pointer rounded-lg transition-colors"
              >
                <MdClose size={24} className="text-[#EE4423]" />
              </button>
            </div>

            {/* Campaign Cards */}
            <div className="p-4 space-y-4" >
              {campaigns.map((campaign) => (
                <motion.div
                  key={campaign.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.1 * campaign.id }}
                  className="rounded-2xl overflow-hidden cursor-pointer bg-gray-800/50 border border-gray-700/50"
                  style={{
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 0 14px 0 #0000001a'
                  }}
                >
                  {/* Campaign Image */}
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={campaign.image}
                      alt={campaign.title}
                      className="w-full h-full object-cover object-top"
                    />
                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-[#212121] via-transparent to-transparent" />
                  </div>

                  {/* Campaign Info */}
                  <div className="p-3">
                    <div className="flex items-start justify-between mb-">
                      <h3 className="text-white font-normal text-sm">{campaign.title}</h3>
                      <span className="px-3 py-1 bg-gray-700 text-white text-[10px] font-light rounded-full">
                        {campaign.rating}
                      </span>
                    </div>
                    
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default CampaignDrawer;
